import React, { useEffect } from 'react';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { mixpanel } from '@fiverr-private/obs';
import { getMixPanelCommonProperties, onImpression } from '@fiverr-private/homepage_utils';
import { EnrichedImpressionData } from '@fiverr-private/homepage_common_types';
import { IWithImpressionProps } from './types';

const WithImpression = (props: IWithImpressionProps): React.JSX.Element => {
    const { children, biEnrichment, onImpressionIdAssign, mixPanelEventPrefix, intersectionThreshold } = props;

    const [ref, itemId] = useImpressionItem({
        enrichment: biEnrichment,
        sendImpressionToBQ: false,
        intersectionThreshold,
        onImpression: async (impressionData: EnrichedImpressionData) => {
            await onImpression(impressionData);
            mixpanel.track(`Home - ${mixPanelEventPrefix} Impression`, {
                ...(impressionData.projectName ? { 'Project Name': impressionData.projectName } : {}),
                ...(biEnrichment.primarySize ? { 'Primary Size': biEnrichment.primarySize } : {}),
                ...(impressionData.first_tab_asset ? { 'First Tab Asset': biEnrichment.first_tab_asset } : {}),
                ...(impressionData.first_tab_logic ? { 'First Tab Logic': biEnrichment.first_tab_logic } : {}),
                ...(impressionData.shown_tabs ? { 'Shown Tabs': biEnrichment.shown_tabs } : {}),
                ...getMixPanelCommonProperties({
                    layoutId: impressionData.layoutId,
                    buyerState: impressionData.buyerState,
                }),
            });
        },
    });

    useEffect(() => {
        if (itemId) {
            onImpressionIdAssign(itemId);
        }
    }, [itemId, onImpressionIdAssign]);

    return <span ref={ref}>{children}</span>;
};

export default WithImpression;
